
export function extractVidId(url: string)
{
    let link = url;
    let ref = link.split('/');
    let vRef = ref[ref.length - 1].split('&');
    vRef = vRef[0].split('=');
    return (vRef.length > 1) ? vRef[1] : vRef[0];
}
